import { Barrio } from "@/shared/types/barrio";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface BarrioEditRequest {
    nombre: string;
    codigo: string;
    ciudadId: string;
}

export async function editBarrio(id: string, request: BarrioEditRequest): Promise<Barrio> {
    await sleep (1000);
    const response = await api.put("barrios/" + id, request);
    return response.data;
}

export function useEditBarrioMutation(id: string, mutationConfig: MutationConfig<Barrio, BarrioEditRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request: BarrioEditRequest) => await editBarrio(id, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["barrios"] });
        },
    });
}

export interface EditBarrioMutationProps {
    id: string;
    mutationConfig?: MutationConfig<Barrio, BarrioEditRequest>;
    children?: (mutationResult: MutationResult<Barrio, BarrioEditRequest>) => ReactNode;
}

export function EditBarrioMutation({
    id,
    children,
    mutationConfig,
}: EditBarrioMutationProps) {
    const mutationResult = useEditBarrioMutation(id, mutationConfig);
    return children && children(mutationResult);
}
